<template>
  <div class="rounded-2xl border border-gray-200 bg-white overflow-hidden animate-pulse">
    <div class="h-1.5 bg-slate-200" />

    <div class="flex flex-col items-center px-5 pt-5 pb-4">
      <div class="h-14 w-14 rounded-full bg-slate-200 ring-2 ring-slate-100 ring-offset-2" />
      <div class="mt-3 h-4 bg-slate-200 rounded w-3/5" />
      <div class="mt-1.5 h-3 bg-slate-200 rounded w-2/5" />
    </div>

    <div class="border-t border-gray-100 px-5 py-3 flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <div class="h-3.5 w-3.5 bg-slate-200 rounded" />
        <div class="h-3 bg-slate-200 rounded w-24" />
      </div>
      <div class="flex items-center gap-2">
        <div class="h-3.5 w-3.5 bg-slate-200 rounded" />
        <div class="h-3 bg-slate-200 rounded w-32" />
      </div>
    </div>

    <div class="border-t border-gray-100 px-5 py-2.5">
      <div class="h-5 w-20 bg-slate-200 rounded-full" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>
